import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyBookCTA from "@/components/StickyBookCTA";
import SponsorStrip from "@/components/SponsorStrip";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-rgv-black text-white flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20 pb-20 lg:pb-0">{children}</main>
      <SponsorStrip />
      <Footer />
      <StickyBookCTA />
    </div>
  );
}
